import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import Solutions from "@/pages/Solutions";
import SupportedLiving from "@/pages/SupportedLiving";
import ResidentialCare from "@/pages/ResidentialCare";
import DomiciliaryCare from "@/pages/DomiciliaryCare";
import Platform from "@/pages/Platform";
import CQCGovernance from "@/pages/CQCGovernance";
import DataMigration from "@/pages/DataMigration";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfUse from "@/pages/TermsOfUse";
import CookiePolicy from "@/pages/CookiePolicy";
import AccessibilityStatement from "@/pages/AccessibilityStatement";

function SmoothScroll() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onAnchorClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -80 });
        }
      }
    };
    document.addEventListener("click", onAnchorClick);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onAnchorClick);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
}

function PaccareRedirect() {
  useEffect(() => {
    window.location.replace("https://app.ayobell.com/paccare");
  }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <Routes>
          <Route path="/paccare" element={<PaccareRedirect />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/supported-living" element={<SupportedLiving />} />
            <Route path="/residential-care" element={<ResidentialCare />} />
            <Route path="/domiciliary-care" element={<DomiciliaryCare />} />
            <Route path="/platform" element={<Platform />} />
            <Route path="/cqc-governance" element={<CQCGovernance />} />
            <Route path="/data-migration" element={<DataMigration />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            <Route path="/accessibility" element={<AccessibilityStatement />} />
          </Route>
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
